import { getPps } from 'ACTIONS/categories/getPps';
import { API_URLS } from 'CONFIG/API_URLS';
import { PP_TYPE } from 'MODULES/PP_TYPE';

export const getSubscriptionLots = (flush = false, activePage) => (dispatch) => {
    const location = window.location.pathname;
    return dispatch(getPps(location, API_URLS.LOT_SUBSCRIPTIONS, PP_TYPE.filters, flush, false, activePage, undefined, undefined, undefined, undefined, undefined, true));
};
